import { Helmet } from 'react-helmet-async';

type SeoProps = {
  title: string;
  description: string;
  image?: string;
};

export function Seo({ title, description, image }: SeoProps) {
  const fullTitle = `${title} | MORROCARS`;
  return <Helmet>
    <title>{fullTitle}</title>
    <meta name="description" content={description} />
    <meta property="og:title" content={fullTitle} />
    <meta property="og:description" content={description} />
    {image && <meta property="og:image" content={image} />}
    <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
  </Helmet>;
}
